import { SVGProps, Ref, forwardRef, useId } from 'react';

export const TelegramBrandSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => {
    const _uniqueId = useId();
    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.512 10.749q8.859-3.81 11.814-5.024c5.626-2.31 6.795-2.712 7.557-2.725.168-.003.542.038.785.233.205.164.261.386.288.541s.06.51.034.788c-.305 3.162-1.624 10.837-2.295 14.379-.284 1.498-.843 2-1.384 2.05-1.177.107-2.07-.767-3.21-1.505-1.782-1.154-2.79-1.872-4.52-2.998-2-1.301-.704-2.016.436-3.185.298-.306 5.482-4.96 5.582-5.383.012-.053.024-.25-.094-.354-.119-.104-.294-.068-.42-.04q-.268.06-8.545 5.576-1.212.822-2.197.801c-.723-.015-2.114-.403-3.149-.735-1.268-.407-2.276-.623-2.189-1.314q.069-.54 1.507-1.105"
                fill={`url(#${_uniqueId}paint0_linear_107_429)`}
                suppressHydrationWarning
            />
            <defs>
                <linearGradient
                    id={`${_uniqueId}paint0_linear_107_429`}
                    x1={1101}
                    y1={3}
                    x2={1101}
                    y2={1789.65}
                    gradientUnits="userSpaceOnUse"
                    suppressHydrationWarning
                >
                    <stop stopColor="#2AABEE" />
                    <stop offset={1} stopColor="#229ED9" />
                </linearGradient>
            </defs>
        </svg>
    );
});
TelegramBrandSize24Glyph.displayName = 'TelegramBrandSize24Glyph';
